// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { totalDataPerDay as calcTotalDataPerDay, getCiscoRatio } from '../../utils/statsUtils';
// css
import '../../styles/components/analytics/DataSources.scss';


class DataSources extends Component {

  getCiscoDataPerDay(item) {
    return calcTotalDataPerDay(item) * getCiscoRatio(item);
  }

  getNonCiscoDataPerDay(item) {
    return calcTotalDataPerDay(item) * (1 - getCiscoRatio(item));
  }

  renderRows() {
    return this.props.completedActiveConfiguredItems.map((configuredItem, index) => (
      <tr className={`analytics__data-sources__table-row--${index % 2 === 0 ? 'even' : 'odd'}`} key={index}>
        <td>{configuredItem.title}</td>
        <td>
          <FormattedNumber value={configuredItem.totalDataPerDay} maximumFractionDigits={1} />
        </td>
        <td className='analytics__data-sources__cisco-split'>
          <FormattedNumber value={this.getNonCiscoDataPerDay(configuredItem)} maximumFractionDigits={1} />
        </td>
        <td className='analytics__data-sources__cisco-split'>
          <FormattedNumber value={this.getCiscoDataPerDay(configuredItem)} maximumFractionDigits={1} />
        </td>
      </tr>
    ));
  }

  render() {
    const { completedActiveConfiguredItems, totalDataPerDay } = this.props;

    const totalNonCisco = completedActiveConfiguredItems.reduce(
      (sum, item) => sum + this.getNonCiscoDataPerDay(item), 0
    );
    const totalCisco = completedActiveConfiguredItems.reduce(
      (sum, item) => sum + this.getCiscoDataPerDay(item), 0
    );

    return (
      <div className='analytics__data-sources'>
        <h2>Recommended Data Sources</h2>
        <table>
          <thead>
            <tr>
              <th>Data Source Type</th>
              <th>Total GB per Day</th>
              <th className='analytics__data-sources__cisco-split'>Non Cisco GB/day</th>
              <th className='analytics__data-sources__cisco-split'>Cisco Data GB/day</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRows()}
          </tbody>
          <tfoot>
            <tr>
              <th>Total</th>
              <th>
                <FormattedNumber value={totalDataPerDay} maximumFractionDigits={1} />
              </th>
              <th className='analytics__data-sources__cisco-split'>
                <FormattedNumber value={totalNonCisco} maximumFractionDigits={1} />
              </th>
              <th className='analytics__data-sources__cisco-split'>
                <FormattedNumber value={totalCisco} maximumFractionDigits={1} />
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}

DataSources.propTypes = {
  completedActiveConfiguredItems: PropTypes.array.isRequired,
  totalDataPerDay: PropTypes.number.isRequired
};

export default DataSources;



// WEBPACK FOOTER //
// ./src/components/analytics/DataSources.js